// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__3WPBs","title":"BackImages_title__1FkAu","images":"BackImages_images__3_nGZ"};